import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Card, Grid, Header } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import MetaDataElementType from './MetaDataElementType';
import { cardcolor } from '../../../app/common/form/errorMessageText';
import LoadingComponent from './../../../app/layout/LoadingComponent';
import UnauthorizedMessage from '../../UnauthorizedMessage';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

const cardStyleLevel5 = {
  display: 'inline-block',
  padding: '10px',
  height: '82vh',
  width: '200pt',
  marginLeft: '30px',
  marginTop: '5px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
  alignItems: 'center',
};
function MetaDataAssetType() {
  const {
    metaDataStore,
    workflowConfigurationStore,
    dashboardStore,
    commonStore,
  } = useStore();
  const {
    metaDataATItems,
    loadMetaDataATById,
    metaDataATRegistry,
    loadMetaDataAT,
    loadingInitialAT,
  } = metaDataStore;

  useEffect(() => {
    if (metaDataATRegistry.size <= 1) loadMetaDataAT();
  }, [metaDataATRegistry.size, loadMetaDataAT]);

  useEffect(() => {
    workflowConfigurationStore.resetWorkflowConfigData();
    // eslint-disable-next-line
  }, []);

  const handleClickAssetType = (id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      loadMetaDataATById(id); // asset type load child inside
      workflowConfigurationStore.setShowAssetTypeName(id);
      workflowConfigurationStore.setShowElementTypesCard(true); // set elementtype  true
      workflowConfigurationStore.setAssetTypeIsActive(true); // set elementtype  true
      workflowConfigurationStore.setShowTemplateCard(false); // set template, task, subtask, element   false
      workflowConfigurationStore.setShowTaskCard(false); // set template, task, subtask, element   false
      workflowConfigurationStore.setShowSubTaskCard(false); // set template, task, subtask, element   false
      workflowConfigurationStore.setShowElementCard(false); // set template, task, subtask, element   false
    }
    workflowConfigurationStore.setEditClickedElement(false);
    workflowConfigurationStore.WorkflowConfiguration.metaDataConfigurationName =
      '';
  };

  const MetaDataATJSX = (
    <Card className="workflow-config-assettypes">
      {metaDataATItems.map((assetType, index) => (
        <Card.Content
          key={index}
          onMouseEnter={() => workflowConfigurationStore.setAssetTypeKey(index)}
          onMouseLeave={() => workflowConfigurationStore.setAssetTypeKey(null)}
          style={
            assetType.id ===
            workflowConfigurationStore.WorkflowConfiguration.showassetTypeName
              ? cardcolor
              : null
          }
          onClick={() => handleClickAssetType(assetType.id)}
        >
          <Grid className="hoverColor" columns={1}>
            <Grid.Row columns={3}>
              <Grid.Column width={11}>{assetType.typeName}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      ))}
    </Card>
  );
  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('SWMB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('SWMB01') && (
        <>
          <Header
            style={{ marginLeft: '20px' }}
            icon="cogs"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].Sidebar.M18 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            sub
            color="grey"
          />
          <div
            style={{
              marginTop: '30px',
              marginRight: '10px',
              height: '85vh',
              marginLeft: '10px',
            }}
          >
            <Grid>
              <Card style={cardStyleLevel5}>
                <Header
                  style={{ marginLeft: '20px' }}
                  size="huge"
                  as="h1"
                  content={
                    (userLanguage[0].SettingsWORKFLOW.SWL02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                  sub
                  color="grey"
                />

                {!metaDataATItems || loadingInitialAT ? (
                  <LoadingComponent />
                ) : (
                  MetaDataATJSX
                )}
              </Card>
              {workflowConfigurationStore.WorkflowConfiguration
                .showElementTypesCard ? (
                <MetaDataElementType />
              ) : null}
            </Grid>
          </div>
        </>
      )}
    </>
  );
}
export default observer(MetaDataAssetType);